import { createSlice } from '@reduxjs/toolkit';
import { setSendMethod } from 'redux/actions';
import { windowStore } from 'util/windowStore';
import { cacheKey } from 'appConstants';

const initialState = {
  sendMethod: windowStore.get(cacheKey.SEND_METHOD) || 'Enter',
};

const persistedSlice = createSlice({
  name: 'persisted',
  initialState,
  reducers: {},

  extraReducers: (builder) => {
    builder.addCase(setSendMethod, (state, action) => {
      state.sendMethod = action.payload;
    });
  },
});

export default persistedSlice;
